import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import sortBy from "../../../../../../assets/AccountingModule/filter.svg";
import edit from "../../../../../../assets/AccountingModule/edit2.svg";
import view from "../../../../../../assets/AccountingModule/view.svg";
import deleteIcon from "../../../../../../assets/AccountingModule/delete.svg";
import dropDownBlack from "../../../../../../assets/AccountingModule/dropdown_black.svg";
import { formatDate } from "../../../../../../utils/DateFormat";
import styles from "./style";
import Modal from "../../../../../../components/Modal";
import CustomPagination from "../../../../../../components/CustomPagination";

const NotesHomePage = ({
  creditNoteData,
  total,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  handleDelete
}) => {
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [opens, setOpens] = useState(false);

  const handleNavigate = (item) => {
    navigate("/dashboard/notesHome/editNotes", { state: { item } });  // Fix this path
  };

  const handleNavigateView = (item) => {
    navigate("/dashboard/viewNotes", { state: { item } });
  };

  const handleDeleteItem = (deleteId) => {
    handleDelete(deleteId)
    setOpens(false);
  };

  return (
    <>
      <Box px="20px" mt={2}>
        <Box sx={styles.header}>
          <Typography sx={styles.headerText}>All Notes</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("createNotes")}
            sx={styles.addButton}
          >
            Create Credit Notes
          </Button>
        </Box>
      </Box>
      <Box sx={styles.container}>
        <Box sx={styles.filterSection}>
          <Box sx={styles.searchContainer}>
            <input
              type="text"
              placeholder="Search"
              style={styles.searchInput}
            />
          </Box>
          <Box sx={styles.sortByContainer}>
            <img src={sortBy} alt="sortBy" />
            <Typography sx={styles.sortByText}>Sort By</Typography>
          </Box>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={styles.tableCell}>Date</TableCell>
                <TableCell sx={styles.tableCell}>Credit Notes#</TableCell>
                <TableCell sx={styles.tableCell}>Customer Name</TableCell>
                <TableCell sx={styles.tableCell}>Invoice# </TableCell>
                <TableCell sx={styles.tableCell}>Status</TableCell>
                <TableCell sx={styles.tableCell}>Amount</TableCell>
                <TableCell sx={styles.tableCell}>Balance</TableCell>
                <TableCell sx={styles.tableCell}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {creditNoteData.length === 0
                ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                )
                : (
                  creditNoteData.map((row) => (
                    <TableRow key={row._id}>
                      <TableCell sx={styles.tableCells}>
                        {formatDate(row?.creditNoteDate) || "N/A"}
                      </TableCell>
                      <TableCell sx={styles.tableCells}>
                        {row?.creditNoteNumber || "N/A"}
                      </TableCell>
                      <TableCell sx={styles.tableCells}>
                        {row?.customer?.name || "N/A"}
                      </TableCell>
                      <TableCell
                        sx={{
                          ...styles.tableCells,
                          maxWidth: 200,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={row?.invoice
                          ?.map((obj) => obj?.invoiceNo)
                          .join(", ")}
                      >
                        {row?.invoice?.map((obj) => obj?.invoiceNo).join(", ") || "N/A"}
                      </TableCell>
                      <TableCell sx={styles.statusCell}>
                        <Typography
                          sx={{
                            ...styles.statusChip,
                            color: getStatusColor(row?.status).color,
                          }}
                        >
                          {row?.status || "N/A"}
                        </Typography>
                      </TableCell>
                      <TableCell sx={styles.tableCells}>
                        {row.grandTotal
                          ? `${row.grandTotal.toLocaleString()}`
                          : "-"}
                      </TableCell>
                      <TableCell sx={styles.tableCells}>
                        {row.balance ? `${row.balance.toLocaleString()}` : "N/A"}
                      </TableCell>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => handleNavigate(row)}
                        >
                          <img src={edit} alt="edit" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleNavigateView(row)}
                        >
                          <img src={view} alt="view" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => {
                            setItem(row);
                            setOpens(true);
                          }}
                        >
                          <img src={deleteIcon} alt="delete" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
            </TableBody>
          </Table>
          <CustomPagination
            pageCount={total}
            totalItems={total}
            page={currentPage}
            setPage={setCurrentPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        </TableContainer>
      </Box>

      <Modal
        open={opens}
        setOpen={setOpens}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Credit Note"}
        handleDelete={() => handleDeleteItem(item?._id)}
      >
        <Box>
          <Typography>Are you sure you want to delete this quote?</Typography>
        </Box>
      </Modal>
    </>
  );
};

// Helper function to get status colors
const getStatusColor = (status) => {
  switch (status) {
    case "Draft":
      return { color: "#878787" };
    case "Open":
      return { color: "#00ABF4" };
    case "Closed":
      return { color: "#28AA4A" };
    case "Cancelled":
      return { color: "#e93030" };
    default:
      return { color: "#000000", bgColor: "#FFFFFF" };
  }
};

export default NotesHomePage;
